<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Bölge Kodu</label>
            <input type="text" class="form-control" v-model="value.RegionCode" placeholder="Bölge Kodu" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bölge Adı</label>
            <input type="text" class="form-control" v-model="value.RegionName" placeholder="Bölge Adı" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <input type="text" class="form-control" v-model="value.RegionDescription" placeholder="Açıklama" />
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.IsOwnFirm">Vişne Madencilik firması mı?</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    props:{
        value:Object
    },
    components:{
        BFormCheckbox
    },
    data(){
        return{
           
        }
    },
}
</script>

<style>

</style>